import React, { useCallback, useEffect, useState } from "react";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import { useAppDispatch } from "../../../redux/app/hooks";
import {
  fetchPublicContractCountsAsync,
  fetchPublicContractsAsync,
} from "../../../redux/features/publicContractSlice";
import { PublicContract } from "../../../redux/features/types/publicContractTypes";
import PublicContractSummary from "./PublicContractSummary";
import PublicContractsTable from "./PublicContractsTable";
import UpdateStatusModal from "./UpdateStatusModal";
import { InvoiceFilterBar, useInvoiceFilters } from "./InvoiceFilters";

const PublicContractManagement = () => {
  const dispatch = useAppDispatch();
  const filters = useInvoiceFilters();
  const { query, page, setPage, setLimit } = filters;

  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedContract, setSelectedContract] =
    useState<PublicContract | null>(null);

  useEffect(() => {
    dispatch(fetchPublicContractCountsAsync());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchPublicContractsAsync(query));
  }, [dispatch, query]);

  const handleUpdateStatus = useCallback((contract: PublicContract) => {
    setSelectedContract(contract);
    setStatusModalOpen(true);
  }, []);

  return (
    <div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6 md:p-8 bg-gray-100 min-h-screen">
      <div>
        <h1 className="text-2xl font-bold">Invoice Management</h1>
      </div>

      <PublicContractSummary />

      <WhiteTitledCard>
        <InvoiceFilterBar filters={filters} />

        <PublicContractsTable
          page={page}
          onPageChange={setPage}
          onLimitChange={(value) => {
            setLimit(value);
            setPage(0);
          }}
          onUpdateStatus={handleUpdateStatus}
        />
      </WhiteTitledCard>

      {statusModalOpen && selectedContract && (
        <UpdateStatusModal
          key={selectedContract.id}
          open={statusModalOpen}
          onClose={() => {
            setStatusModalOpen(false);
            setSelectedContract(null);
          }}
          contract={selectedContract}
          listQuery={query}
        />
      )}
    </div>
  );
};

export default PublicContractManagement;
